/**
 * Labead Front - Scripts para frontend (aluno)
 *
 * @package Labead
 */

// htmx + Alpine.js (partial page loading, reactive UI).
import './parts/gestao/htmx-init.js';

// Lib loader — initialize external libs (FullCalendar, Select2, etc.) on page load.
import lbLibs from './parts/libs/lib-loader.js';
lbLibs.initDom(document);

// especifico.
//import './parts/labead/labead.js';
import './parts/labead/parcelas.js'; 
